import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { grey } from 'globals/colors';
import { TypographyAllProps } from 'globals/types';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import FsSubtitle from 'ui-elements/typography/FsSubtitle';

export const ContainerBox = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
  },
}))((props: BoxProps) => <Box {...props} />);

export const BarContainer = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    backgroundColor: grey.V5,
  },
}))((props: BoxProps) => <Box {...props} />);

export const BarPointer = withStyles({})((props: BoxProps) => (
  <Box width="100%" {...props} />
));

export const InfoBox = withStyles(({ spacing }: Theme) => ({
  root: {
    paddingLeft: spacing(1),
  },
}))((props: BoxProps) => <Box {...props} />);

export const Title = withStyles(() => ({
  root: {
    fontWeight: 500,
  },
}))((props: TypographyAllProps) => (
  <FsBodyExtraSmall component="h5" {...props} />
));

export const Line = withStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.grey[400],
    width: 17,
    height: 2,
    margin: theme.spacing(0.5, 0),
  },
}))((props) => <Divider {...props} />);

export const Value = withStyles({})((props: TypographyAllProps) => (
  <FsSubtitle component="strong" {...props} />
));

export const Description = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
    lineHeight: 1.2,
  },
}))((props: TypographyAllProps) => (
  <FsBodyExtraSmall component="p" {...props} />
));
